import React, { useEffect, createElement } from 'react';
import { CheckIcon, StarIcon, ShieldCheckIcon, CreditCardIcon, ZapIcon, FlameIcon, XIcon } from 'lucide-react';
export function SalesPage() {
  useEffect(() => {
    // Meta Pixel Code
    const w = window as any;
    if (w.fbq) return;
    const n = w.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!w._fbq) w._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [] as any[];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    w.fbq('init', '1688179945683486');
    w.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-white" data-id="element-2">
      {/* Meta Pixel noscript */}
      <noscript data-id="element-3">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1688179945683486&ev=PageView&noscript=1" alt="" data-id="element-4" />
      </noscript>

      {/* Attention Banner */}
      <div className="bg-gradient-to-r from-[#F5821F] to-orange-600 py-3 px-4" data-id="element-5">
        <div className="max-w-6xl mx-auto" data-id="element-6">
          <p className="text-center text-sm md:text-base font-semibold text-white" data-id="element-7">
            🍗 ATENCIÓN: PERSONAS QUE BUSCAN BAJAR DE PESO, SIN DIETA ESTRICTA.
          </p>
        </div>
      </div>

      {/* Hero Section */}
      <section className="max-w-6xl mx-auto px-4 py-8 md:py-12" data-id="element-8">
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-center mb-6 leading-tight text-[#1A1A1A]" data-id="element-9">
          Come lo que te gusta. <br data-id="element-10" />
          <span className="text-[#4CAF72]" data-id="element-11">
            Pierde los kilos que te sobran.
          </span>
        </h1>

        <div className="max-w-4xl mx-auto mb-6" data-id="element-12">
          <img src="https://cdn.magicpatterns.com/uploads/85gLHmje8C1y2zEXwPpS9o/ChatGPT_Image_29_abr_2026,_12_00_45.png" alt="MegaPack Adelgaza con Air Fryer" className="w-full rounded-2xl shadow-xl" data-id="element-13" />
        </div>

        <div className="max-w-3xl mx-auto mb-8" data-id="element-14">
          <div className="bg-[#F0FAF4] border-l-4 border-[#4CAF72] p-6 rounded-r-lg" data-id="element-15">
            <p className="text-lg md:text-xl leading-relaxed text-[#333333]" data-id="element-16">
              El único sistema{' '}
              <span className="text-[#F5821F] font-semibold" data-id="element-17">
                "Abrir y Cocinar"
              </span>{' '}
              que transforma tu freidora de aire en una máquina de quemar grasa.
              Sin pasar hambre, sin contar calorías y sin efecto rebote.
            </p>
          </div>
        </div>

        <div className="text-center mb-6" data-id="element-18">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#4CAF72]" data-id="element-19">
            MEGAPACK ADELGAZA CON AIR FRYER™
          </h2>
          <div className="flex items-center justify-center gap-2 mb-3" data-id="element-20">
            <div className="flex" data-id="element-21">
              {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="w-6 h-6 fill-[#F5821F] text-[#F5821F]" data-id="element-22" />)}
            </div>
            <span className="text-lg text-[#333333]" data-id="element-23">
              4,9/5 (+1.200 Verificados)
            </span>
          </div>
          <div className="flex items-center justify-center gap-2 text-[#F5821F] font-semibold mb-6" data-id="element-24">
            <FlameIcon className="w-5 h-5" data-id="element-25" />
            <span data-id="element-26">24 personas compraron hoy</span>
          </div>

          <a href="#pricing" className="inline-block bg-[#F5821F] hover:bg-orange-600 text-white font-bold text-lg px-12 py-5 rounded-full shadow-lg transform hover:scale-105 transition-all duration-200 mb-4" data-id="element-27">
            🚀 ¡SÍ! QUIERO ADELGAZAR HOY
          </a>

          <div className="flex flex-wrap items-center justify-center gap-4 text-sm text-[#333333]" data-id="element-28">
            <div className="flex items-center gap-2" data-id="element-29">
              <ZapIcon className="w-4 h-4 text-[#4CAF72]" data-id="element-30" />
              <span data-id="element-31">Acceso Inmediato</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-32">
              <ShieldCheckIcon className="w-4 h-4 text-[#4CAF72]" data-id="element-33" />
              <span data-id="element-34">Garantía 7 Días</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-35">
              <CreditCardIcon className="w-4 h-4 text-[#4CAF72]" data-id="element-36" />
              <span data-id="element-37">Pago Único</span>
            </div>
          </div>
        </div>

        <div className="bg-[#F0FAF4] border border-[#E8F5ED] rounded-lg p-4 max-w-2xl mx-auto text-center" data-id="element-38">
          <p className="text-sm md:text-base text-[#333333]" data-id="element-39">
            🇪🇸 Diseñado para España — Mercadona, Lidl y Alcampo. Sin
            ingredientes raros.
          </p>
        </div>
      </section>

      {/* Problem Statement */}
      <section className="bg-[#F9F9F9] py-8" data-id="element-40">
        <div className="max-w-6xl mx-auto px-4" data-id="element-41">
          <div className="bg-white rounded-2xl p-8 md:p-12 border border-[#E8F5ED] shadow-sm" data-id="element-42">
            <p className="text-xl md:text-2xl text-center leading-relaxed text-[#333333]" data-id="element-43">
              El 95% de las personas que hacen dieta recuperan el peso en menos
              de un año.
              <span className="text-[#4CAF72] font-semibold" data-id="element-44">
                {' '}
                El problema no es tu voluntad.
              </span>{' '}
              Es que nadie te dio el sistema correcto.
            </p>
          </div>
        </div>
      </section>

      {/* Comparison Table */}
      <section className="max-w-6xl mx-auto px-4 py-8" data-id="element-45">
        <div className="overflow-x-auto" data-id="element-46">
          <table className="w-full bg-white rounded-2xl overflow-hidden border border-[#E8F5ED] shadow-sm" data-id="element-47">
            <thead data-id="element-48">
              <tr className="bg-[#F9F9F9]" data-id="element-49">
                <th className="px-6 py-4 text-left text-lg font-bold text-[#E53935]" data-id="element-50">
                  SIN EL MEGAPACK
                </th>
                <th className="px-6 py-4 text-left text-lg font-bold text-[#4CAF72]" data-id="element-51">
                  CON EL MEGAPACK
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-[#E8F5ED]" data-id="element-52">
              <tr data-id="element-53">
                <td className="px-6 py-4 text-[#666666]" data-id="element-54">
                  <XIcon className="w-5 h-5 inline mr-2 text-[#E53935]" data-id="element-55" />
                  Pollo hervido y ensalada — otra vez
                </td>
                <td className="px-6 py-4 text-[#333333]" data-id="element-56">
                  <CheckIcon className="w-5 h-5 inline mr-2 text-[#4CAF72]" data-id="element-57" />
                  Recetas crujientes listas en 15 minutos
                </td>
              </tr>
              <tr data-id="element-58">
                <td className="px-6 py-4 text-[#666666]" data-id="element-59">
                  <XIcon className="w-5 h-5 inline mr-2 text-[#E53935]" data-id="element-60" />
                  Dieta abandonada el jueves
                </td>
                <td className="px-6 py-4 text-[#333333]" data-id="element-61">
                  <CheckIcon className="w-5 h-5 inline mr-2 text-[#4CAF72]" data-id="element-62" />
                  Un plan que puedes mantener sin sufrimiento
                </td>
              </tr>
              <tr data-id="element-63">
                <td className="px-6 py-4 text-[#666666]" data-id="element-64">
                  <XIcon className="w-5 h-5 inline mr-2 text-[#E53935]" data-id="element-65" />
                  Air Fryer cogiendo polvo
                </td>
                <td className="px-6 py-4 text-[#333333]" data-id="element-66">
                  <CheckIcon className="w-5 h-5 inline mr-2 text-[#4CAF72]" data-id="element-67" />
                  Tu freidora trabajando para ti cada día
                </td>
              </tr>
              <tr data-id="element-68">
                <td className="px-6 py-4 text-[#666666]" data-id="element-69">
                  <XIcon className="w-5 h-5 inline mr-2 text-[#E53935]" data-id="element-70" />
                  Antojo nocturno que arruina todo
                </td>
                <td className="px-6 py-4 text-[#333333]" data-id="element-71">
                  <CheckIcon className="w-5 h-5 inline mr-2 text-[#4CAF72]" data-id="element-72" />
                  Postres saludables que frenan el antojo
                </td>
              </tr>
              <tr data-id="element-73">
                <td className="px-6 py-4 text-[#666666]" data-id="element-74">
                  <XIcon className="w-5 h-5 inline mr-2 text-[#E53935]" data-id="element-75" />
                  Efecto rebote garantizado
                </td>
                <td className="px-6 py-4 text-[#333333]" data-id="element-76">
                  <CheckIcon className="w-5 h-5 inline mr-2 text-[#4CAF72]" data-id="element-77" />
                  Sistema de mantenimiento incluido
                </td>
              </tr>
              <tr data-id="element-78">
                <td className="px-6 py-4 text-[#666666]" data-id="element-79">
                  <XIcon className="w-5 h-5 inline mr-2 text-[#E53935]" data-id="element-80" />
                  Lunes empezando de cero siempre
                </td>
                <td className="px-6 py-4 text-[#333333]" data-id="element-81">
                  <CheckIcon className="w-5 h-5 inline mr-2 text-[#4CAF72]" data-id="element-82" />
                  Resultados que se mantienen de verdad
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      {/* For You If */}
      <section className="bg-[#F9F9F9] py-8" data-id="element-83">
        <div className="max-w-6xl mx-auto px-4" data-id="element-84">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-8 text-[#4CAF72]" data-id="element-85">
            Este sistema es para ti si…
          </h2>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-86">
            {['Tienes Air Fryer en casa pero no sabes cómo usarla para adelgazar de verdad', 'Empiezas dietas con fuerza y las abandonas antes del fin de semana', 'Estás harta de comer aburrido mientras el resto de la familia come bien', 'Quieres perder peso sin pastillas, sin batidos y sin pasar hambre'].map((item, index) => <div key={index} className="flex items-start gap-4 bg-white p-6 rounded-xl border border-[#E8F5ED] shadow-sm" data-id="element-87">
                <CheckIcon className="w-6 h-6 text-[#4CAF72] flex-shrink-0 mt-1" data-id="element-88" />
                <p className="text-lg text-[#333333]" data-id="element-89">{item}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* What's Included */}
      <section className="max-w-6xl mx-auto px-4 py-8" data-id="element-90">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-3 text-[#4CAF72]" data-id="element-91">
          ¿Qué incluye el MegaPack?
        </h2>
        <p className="text-xl text-center text-[#666666] mb-8" data-id="element-92">
          6 libros PDF listos para usar desde hoy mismo
        </p>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-93">
          {[{
          icon: '📗',
          title: 'LIBRO 1 — Cómo Adelgazar con Air Fryer',
          description: 'La base del sistema. Qué comer, qué evitar y por qué funciona cuando todo lo demás ha fallado.'
        }, {
          icon: '📙',
          title: 'LIBRO 2 — Recetas del Día a Día',
          description: '+50 recetas en menos de 20 minutos. Pollo crujiente, salmón, aperitivos. Comida real que te apetece comer.'
        }, {
          icon: '📘',
          title: 'LIBRO 3 — Planifica tus Comidas',
          description: 'Nunca más improvises. Abre el libro, sigue el plan. Tan simple como eso.'
        }, {
          icon: '📕',
          title: 'LIBRO 4 — Batch Cooking con Air Fryer',
          description: 'Cocina una vez. Come sano toda la semana. Ahorra tiempo y energía.'
        }, {
          icon: '📓',
          title: 'LIBRO 5 — Postres sin Culpa',
          description: 'El antojo resuelto de una vez. Postres y snacks saludables para las noches difíciles.'
        }, {
          icon: '📔',
          title: 'LIBRO 6 — Sin Efecto Rebote',
          description: 'El sistema para mantener los resultados de por vida. Sin volver al punto de partida.'
        }].map((book, index) => <div key={index} className="bg-white p-6 rounded-xl border border-[#E8F5ED] hover:border-[#4CAF72] transition-colors shadow-sm" data-id="element-94">
              <div className="text-4xl mb-4" data-id="element-95">{book.icon}</div>
              <h3 className="text-lg font-bold mb-3 text-[#F5821F]" data-id="element-96">
                {book.title}
              </h3>
              <p className="text-[#666666]" data-id="element-97">{book.description}</p>
            </div>)}
        </div>
      </section>

      {/* Preview Images */}
      <section className="bg-[#F9F9F9] py-8" data-id="element-98">
        <div className="max-w-6xl mx-auto px-4" data-id="element-99">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-3 text-[#4CAF72]" data-id="element-100">
            📸 MIRA EL MATERIAL POR DENTRO
          </h2>
          <p className="text-xl text-center text-[#666666] mb-8" data-id="element-101">
            Esto es exactamente lo que recibes hoy
          </p>

          <div className="grid md:grid-cols-2 gap-6 mb-6" data-id="element-102">
            {['https://cdn.magicpatterns.com/uploads/v561zTu3z4CeQkcuc4X5ue/WhatsApp_Image_2026-05-04_at_19.16.33_(3).jpg', 'https://cdn.magicpatterns.com/uploads/7gtpJtn71VZ5rFpjWVgYuG/WhatsApp_Image_2026-05-04_at_19.16.33_(2).jpg', 'https://cdn.magicpatterns.com/uploads/dbMtuhZkEwddgGYxQ8bzEP/WhatsApp_Image_2026-05-04_at_19.16.32_(2).jpg', 'https://cdn.magicpatterns.com/uploads/68eksqueeojJNCbAsnxWFa/WhatsApp_Image_2026-05-04_at_19.16.32_(1).jpg'].map((img, index) => <div key={index} className="rounded-xl overflow-hidden shadow-lg border border-[#E8F5ED]" data-id="element-103">
                <img src={img} alt={`Preview ${index + 1}`} className="w-full h-auto" data-id="element-104" />
              </div>)}
          </div>

          <p className="text-center text-xl text-[#333333]" data-id="element-105">
            No compras a ciegas. Sabes exactamente lo que recibes.
          </p>
        </div>
      </section>

      {/* Bonuses */}
      <section className="max-w-6xl mx-auto px-4 py-8" data-id="element-106">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-3 text-[#4CAF72]" data-id="element-107">
          6 Bonos Estratégicos Incluidos
        </h2>
        <p className="text-xl text-center text-[#666666] mb-8" data-id="element-108">
          Sin coste extra — Valor total: 22,00€
        </p>

        <div className="space-y-6" data-id="element-109">
          {[{
          icon: '🎁',
          title: 'Plan Semanal Completo',
          description: 'Tu semana resuelta de domingo a domingo. Sin improvisar. Sin Glovo.',
          badge: 'GRATIS'
        }, {
          icon: '🎁',
          title: 'Guía de Cocción Air Fryer',
          description: 'Temperaturas y tiempos exactos para cada alimento. Nunca más carne seca.',
          badge: 'GRATIS'
        }, {
          icon: '🎁',
          title: 'Lista de la Compra Mensual',
          description: 'Entra al Mercadona con un plan. Sal en 20 minutos.',
          badge: 'GRATIS'
        }].map((bonus, index) => <div key={index} className="bg-white p-6 rounded-xl border border-[#E8F5ED] flex items-start gap-4 shadow-sm" data-id="element-110">
              <div className="text-4xl" data-id="element-111">{bonus.icon}</div>
              <div className="flex-1" data-id="element-112">
                <h3 className="text-xl font-bold mb-2 text-[#1A1A1A]" data-id="element-113">
                  {bonus.title}
                </h3>
                <p className="text-[#666666]" data-id="element-114">{bonus.description}</p>
              </div>
              <span className="bg-[#4CAF72] text-white px-4 py-1 rounded-full text-sm font-bold whitespace-nowrap" data-id="element-115">
                {bonus.badge}
              </span>
            </div>)}
        </div>
      </section>

      {/* Pricing */}
      <section id="pricing" className="bg-[#F9F9F9] py-8" data-id="element-116">
        <div className="max-w-6xl mx-auto px-4" data-id="element-117">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-8 text-[#4CAF72]" data-id="element-118">
            La Oferta
          </h2>

          <div className="bg-white rounded-2xl p-8 mb-8 border border-[#E8F5ED] shadow-sm" data-id="element-119">
            <h3 className="text-2xl font-bold mb-6 text-center text-[#1A1A1A]" data-id="element-120">
              TODO ESTO POR SEPARADO:
            </h3>
            <div className="overflow-x-auto" data-id="element-121">
              <table className="w-full" data-id="element-122">
                <tbody className="divide-y divide-[#E8F5ED]" data-id="element-123">
                  <tr data-id="element-124">
                    <td className="py-3 text-lg text-[#333333]" data-id="element-125">
                      MegaPack (6 Libros)
                    </td>
                    <td className="py-3 text-right text-xl font-bold text-[#1A1A1A]" data-id="element-126">
                      49,00€
                    </td>
                  </tr>
                  <tr data-id="element-127">
                    <td className="py-3 text-lg text-[#333333]" data-id="element-128">
                      Sistema AIR‑FAST 7
                    </td>
                    <td className="py-3 text-right text-xl font-bold text-[#1A1A1A]" data-id="element-129">
                      29,00€
                    </td>
                  </tr>
                  <tr data-id="element-130">
                    <td className="py-3 text-lg text-[#333333]" data-id="element-131">
                      3 Bonos Estratégicos
                    </td>
                    <td className="py-3 text-right text-xl font-bold text-[#1A1A1A]" data-id="element-132">
                      22,00€
                    </td>
                  </tr>
                  <tr className="border-t-2 border-[#4CAF72]" data-id="element-133">
                    <td className="py-3 text-xl font-bold text-[#1A1A1A]" data-id="element-134">
                      TOTAL
                    </td>
                    <td className="py-3 text-right text-2xl font-bold text-[#4CAF72]" data-id="element-135">
                      100,00€
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-8" data-id="element-136">
            {/* Base Package */}
            <div className="bg-white rounded-2xl p-8 border-2 border-[#E8F5ED] hover:border-[#4CAF72] transition-colors shadow-sm" data-id="element-137">
              <div className="text-center mb-6" data-id="element-138">
                <h3 className="text-2xl font-bold mb-2 text-[#1A1A1A]" data-id="element-139">
                  📘 MEGAPACK BASE
                </h3>
                <p className="text-[#666666] mb-4" data-id="element-140">6 Libros + 3 Bonos</p>
                <div className="flex items-center justify-center gap-4 mb-4" data-id="element-141">
                  <span className="text-3xl text-[#F5821F] line-through" data-id="element-142">
                    49,00€
                  </span>
                  <span className="text-5xl font-bold text-[#4CAF72]" data-id="element-143">
                    13,99€
                  </span>
                </div>
              </div>
              <a href="https://pagos.digipromarket.com/cart/56222402937158:1" className="block w-full bg-[#4CAF72] hover:bg-green-600 text-white font-bold text-lg py-4 rounded-full text-center transition-colors" data-id="element-144">
                → QUIERO EL MEGAPACK BASE
              </a>
            </div>

            {/* Total Package */}
            <div className="bg-gradient-to-br from-[#F0FAF4] to-white rounded-2xl p-8 border-2 border-[#F5821F] relative shadow-lg" data-id="element-145">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2" data-id="element-146">
                <span className="bg-[#F5821F] text-white px-6 py-2 rounded-full text-sm font-bold" data-id="element-147">
                  La más elegida
                </span>
              </div>
              <div className="text-center mb-6 mt-4" data-id="element-148">
                <h3 className="text-2xl font-bold mb-2 text-[#1A1A1A]" data-id="element-149">
                  🏆 MEGAPACK TOTAL + AIR‑FAST 7 ⭐
                </h3>
                <p className="text-[#666666] mb-2" data-id="element-150">
                  6 Libros + 3 Bonos + Sistema AIR‑FAST 7 de 21 días
                </p>
                <p className="text-sm text-[#4CAF72] mb-4" data-id="element-151">
                  Por solo 6€ más, resultados desde el primer mes
                </p>
                <div className="flex items-center justify-center gap-4 mb-4" data-id="element-152">
                  <span className="text-3xl text-[#F5821F] line-through" data-id="element-153">
                    78,00€
                  </span>
                  <span className="text-5xl font-bold text-[#4CAF72]" data-id="element-154">
                    19,99€
                  </span>
                </div>
              </div>
              <a href="https://pagos.digipromarket.com/cart/56222886723910:1" className="block w-full bg-[#F5821F] hover:bg-orange-600 text-white font-bold text-lg py-4 rounded-full text-center transition-all transform hover:scale-105" data-id="element-155">
                → QUIERO EL MEGAPACK TOTAL + AIR‑FAST 7
              </a>
            </div>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4 text-sm text-[#333333]" data-id="element-156">
            <div className="flex items-center gap-2" data-id="element-157">
              <ZapIcon className="w-4 h-4 text-[#4CAF72]" data-id="element-158" />
              <span data-id="element-159">Acceso Inmediato</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-160">
              <CreditCardIcon className="w-4 h-4 text-[#4CAF72]" data-id="element-161" />
              <span data-id="element-162">Pago Único</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-163">
              <ShieldCheckIcon className="w-4 h-4 text-[#4CAF72]" data-id="element-164" />
              <span data-id="element-165">Garantía 7 Días</span>
            </div>
          </div>
        </div>
      </section>

      {/* Guarantee */}
      <section className="max-w-6xl mx-auto px-4 py-8" data-id="element-166">
        <div className="bg-[#F0FAF4] rounded-2xl p-8 md:p-12 border-2 border-[#4CAF72]" data-id="element-167">
          <div className="flex items-start gap-6" data-id="element-168">
            <ShieldCheckIcon className="w-16 h-16 text-[#4CAF72] flex-shrink-0" data-id="element-169" />
            <div data-id="element-170">
              <h2 className="text-3xl font-bold mb-4 text-[#1A1A1A]" data-id="element-171">
                🛡️ ADELGAZAS O TE DEVOLVEMOS EL DINERO
              </h2>
              <p className="text-lg text-[#333333] mb-4" data-id="element-172">
                Estamos tan seguros de que este sistema funciona que te damos 7
                días para probarlo en tu cocina. Si no es exactamente lo que
                esperabas — te devolvemos el 100%. Sin formularios. Sin
                preguntas. Sin drama.
              </p>
              <p className="text-[#4CAF72] font-semibold" data-id="element-173">
                Tasa de devoluciones: menos del 1%.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="bg-[#F9F9F9] py-8" data-id="element-174">
        <div className="max-w-6xl mx-auto px-4" data-id="element-175">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-8 text-[#4CAF72]" data-id="element-176">
            ❤️ Lo que dicen los que ya lo tienen:
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-177">
            {[{
            name: 'María G.',
            location: 'Madrid',
            rating: 5,
            text: '3 kilos en 5 semanas. Mi familia come lo mismo que yo y no saben que estoy a dieta.'
          }, {
            name: 'Laura P.',
            location: 'Barcelona',
            rating: 5,
            text: '3,5 kilos en 6 semanas trabajando desde casa. El plan semanal eliminó el picar entre horas.'
          }, {
            name: 'Roberto M.',
            location: 'Valencia',
            rating: 5,
            text: 'Siempre recuperaba el peso. El libro Sin Efecto Rebote cambió todo. 4 meses sin subir ni un gramo.'
          }, {
            name: 'Ana T.',
            location: 'Zaragoza',
            rating: 5,
            text: '4 kilos en 7 semanas, sin matarme. Cocino una vez para toda la familia. Mis hijos piden el pollo crujiente cada semana.'
          }, {
            name: 'David S.',
            location: 'Madrid',
            rating: 5,
            text: '5 kilos en 8 semanas. Me ahorro más de 80€ al mes en delivery. El pack se paga solo la primera semana.'
          }, {
            name: 'Patricia L.',
            location: 'Málaga',
            rating: 5,
            text: 'El AIR‑FAST 7 fue la mejor decisión. Los 21 días iniciales me dieron el impulso que nunca tuve con ninguna dieta.'
          }].map((testimonial, index) => <div key={index} className="bg-white p-6 rounded-xl border border-[#E8F5ED] shadow-sm" data-id="element-178">
                <div className="flex mb-3" data-id="element-179">
                  {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-[#F5821F] text-[#F5821F]" data-id="element-180" />)}
                </div>
                <p className="text-[#333333] mb-4" data-id="element-181">{testimonial.text}</p>
                <p className="font-semibold text-[#1A1A1A]" data-id="element-182">
                  {testimonial.name}
                </p>
                <p className="text-sm text-[#666666]" data-id="element-183">{testimonial.location}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="max-w-4xl mx-auto px-4 py-8" data-id="element-184">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-8 text-[#4CAF72]" data-id="element-185">
          ❓ Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-186">
          {[{
          q: '¿Cómo recibo el MegaPack?',
          a: 'Email con acceso inmediato. En 5 minutos en tu móvil, tablet u ordenador.'
        }, {
          q: '¿Necesito una Air Fryer específica?',
          a: 'No. Funciona con cualquier marca y modelo.'
        }, {
          q: '¿Tengo que contar calorías?',
          a: 'No. El sistema ya está equilibrado. Solo cocina y come.'
        }, {
          q: '¿Tiene garantía real?',
          a: '7 días. Devolución del 100% sin preguntas.'
        }].map((faq, index) => <details key={index} className="bg-white rounded-xl border border-[#E8F5ED] overflow-hidden shadow-sm" data-id="element-187">
              <summary className="px-6 py-4 cursor-pointer font-semibold text-lg hover:bg-[#F9F9F9] transition-colors text-[#1A1A1A]" data-id="element-188">
                {faq.q}
              </summary>
              <div className="px-6 pb-4 text-[#666666]" data-id="element-189">{faq.a}</div>
            </details>)}
        </div>
      </section>

      {/* Final CTA */}
      <section className="bg-[#F0FAF4] py-8" data-id="element-190">
        <div className="max-w-6xl mx-auto px-4" data-id="element-191">
          <div className="bg-white rounded-2xl p-12 text-center border-2 border-[#4CAF72] shadow-lg" data-id="element-192">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-[#4CAF72]" data-id="element-193">
              🚀 ¡SÍ! QUIERO ADELGAZAR CON MI AIR FRYER
            </h2>
            <div className="flex flex-wrap items-center justify-center gap-4 text-sm text-[#333333] mb-8" data-id="element-194">
              <div className="flex items-center gap-2" data-id="element-195">
                <ZapIcon className="w-4 h-4 text-[#4CAF72]" data-id="element-196" />
                <span data-id="element-197">Acceso Inmediato</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-198">
                <ShieldCheckIcon className="w-4 h-4 text-[#4CAF72]" data-id="element-199" />
                <span data-id="element-200">Garantía 7 Días</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-201">
                <CreditCardIcon className="w-4 h-4 text-[#4CAF72]" data-id="element-202" />
                <span data-id="element-203">Pago Único</span>
              </div>
            </div>
            <a href="#pricing" className="inline-block bg-[#F5821F] hover:bg-orange-600 text-white font-bold text-xl px-12 py-5 rounded-full shadow-lg transform hover:scale-105 transition-all duration-200" data-id="element-204">
              VER OFERTAS
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#F9F9F9] border-t border-[#E8F5ED] py-8" data-id="element-205">
        <div className="max-w-6xl mx-auto px-4" data-id="element-206">
          <div className="text-center mb-6" data-id="element-207">
            <h3 className="text-2xl font-bold mb-2 text-[#4CAF72]" data-id="element-208">
              🍗 ADELGAZA CON AIR FRYER™
            </h3>
            <p className="text-[#666666] mb-4" data-id="element-209">
              Porque adelgazar no debería costarte todos los lunes del año.
            </p>
            <div className="flex items-center justify-center gap-4 text-sm text-[#666666]" data-id="element-210">
              <span data-id="element-211">📧 digipromarket3@gmail.com</span>
              <span data-id="element-212">📲 @digi.promarket</span>
            </div>
          </div>

          <div className="border-t border-[#E8F5ED] pt-6 text-center text-sm text-[#999999]" data-id="element-213">
            <p className="mb-2" data-id="element-214">
              © Adelgaza con Air Fryer™ 2025 — Todos los derechos reservados.
            </p>
            <p className="mb-4" data-id="element-215">
              Infoproducto digital en PDF. No es un servicio médico ni
              nutricional. Los resultados pueden variar.
            </p>
            <p className="text-lg text-[#666666] italic" data-id="element-216">
              🍗 "La próxima cena puede ser el inicio de tu cambio."
            </p>
          </div>
        </div>
      </footer>
    </div>;
}